import { useContext } from 'react';
import { SelectionActionsContext } from './SelectionContext';

export const useSelectionActions = () => {
  const selectionActions = useContext(SelectionActionsContext);

  if (!selectionActions) {
    throw new Error('Selection actions context not initialized!');
  }

  return selectionActions;
};
